import { gql } from '@apollo/client'

import { BoxLockWithProvider } from './box-lock-with-provider'
import { OpenModalFromPaywallContext, PaywallProvider } from './components'
import { BoxPaywallProps } from './types'
import { useBoxModal } from './use-box-modal'

export function BoxPaywall(props: BoxPaywallProps) {
  const { setOpen } = useBoxModal(props)

  return (
    <OpenModalFromPaywallContext.Provider value={() => setOpen(true)}>
      <PaywallProvider>
        <BoxLockWithProvider {...props} />
      </PaywallProvider>
    </OpenModalFromPaywallContext.Provider>
  )
}

BoxPaywall.fragments = {
  viewer: gql`
    fragment BoxPaywall_viewer on Profile {
      pid
    }
  `,
}
